import { gql } from '@apollo/client'

export const DELETE_ACTIONS = gql`
  mutation DeleteActions($input: DeleteActionsInput!) {
    deleteActions(data: $input)
  }
`
